/**
 * Spinner Component implemented with Material UI
 *
 * This component provides a loading indicator with a circular progress animation.
 */
import React from 'react';
import { Box, CircularProgress, styled, BoxProps, CircularProgressProps } from '@mui/material';
import { SpinnerProps } from 'types/components/atoms';

/**
 * Spinner component
 *
 * @param props - Component props
 * @returns A loading spinner component
 */
const Spinner: React.FC<SpinnerProps> = (props) => {
  return (
    <SpinnerWrapper>
      <StyledCircularProgress aria-label="Loading..." />
    </SpinnerWrapper>
  );
};

// Styled components using MUI styled API
const SpinnerWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '1rem',
  paddingBottom: '1rem',
  position: 'relative',
  width: '4rem',
  height: '4rem',
  margin: '0 auto',
}));

const StyledCircularProgress = styled(CircularProgress)<CircularProgressProps>(({ theme }) => ({
  color: theme.palette.text.primary,
  width: '4rem !important',
  height: '4rem !important',
  '& .MuiCircularProgress-circle': {
    strokeWidth: '0.2rem',
  },
}));

export type { SpinnerProps };
export default Spinner;
